import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import type { ButtonProps } from '@mui/material';
import type { Key } from 'react';

import { usePopover } from '../../hooks/use-popover';
import { ChevronDown as ChevronDownIcon } from '../../icons/chevron-down';

export interface BulkAction {
  id: Key;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
}

interface Props extends ButtonProps {
  selectedCount: number;
  title: string;
  actions: BulkAction[];
  disabled?: boolean;
}

export const BulkActionsMenu = ({ disabled, selectedCount, actions, title, ...other }: Props) => {
  const [anchorRef, open, handleOpen, handleClose] = usePopover();

  return (
    <>
      <Button
        color="primary"
        disabled={disabled}
        onClick={handleOpen}
        ref={anchorRef}
        size="large"
        startIcon={<ChevronDownIcon />}
        variant="outlined"
        {...other}>
        {title}
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {actions.map(action => (
          <Tooltip key={action.id} title={action.tooltip} disableHoverListener={!action.disabled}>
            <span>
              <MenuItem
                onClick={() => {
                  action.onClick();
                  handleClose();
                }}
                disabled={
                  action.disabled ?? false
                }>{`${action.label} (${selectedCount})`}</MenuItem>
            </span>
          </Tooltip>
        ))}
      </Menu>
    </>
  );
};
